import React from 'react';
import './ResultadosMesModal.css';

const DATOS_31_DIAS = [
  { dia: 1,  g: 3,  p: 3,  estado: 'L', b30k: -153,    b100k: -510,    b500k: -2550,    b1m: -5100 },
  { dia: 2,  g: 7,  p: 3,  estado: 'W', b30k: 690,     b100k: 2300,    b500k: 11500,    b1m: 23000 },
  { dia: 3,  g: 5,  p: 1,  estado: 'W', b30k: 1635,    b100k: 5450,    b500k: 27250,    b1m: 54500 },
  { dia: 4,  g: 10, p: 0,  estado: 'W', b30k: 4125,    b100k: 13750,   b500k: 68750,    b1m: 137500 },
  { dia: 5,  g: 8,  p: 2,  estado: 'W', b30k: 5517,    b100k: 18390,   b500k: 91950,    b1m: 183900 },
  { dia: 6,  g: 5,  p: 2,  estado: 'W', b30k: 6162,    b100k: 20540,   b500k: 102700,   b1m: 205400 },
  { dia: 7,  g: 7,  p: 3,  estado: 'W', b30k: 7005,    b100k: 23350,   b500k: 116750,   b1m: 233500 },
  { dia: 8,  g: 8,  p: 3,  estado: 'W', b30k: 8097,    b100k: 26990,   b500k: 134950,   b1m: 269900 },
  { dia: 9,  g: 3,  p: 3,  estado: 'L', b30k: 7944,    b100k: 26480,   b500k: 132400,   b1m: 264800 },
  { dia: 10, g: 4,  p: 6,  estado: 'L', b30k: 7140,    b100k: 23800,   b500k: 119000,   b1m: 238000 },
  { dia: 11, g: 7,  p: 2,  estado: 'W', b30k: 8283,    b100k: 27610,   b500k: 138050,   b1m: 276100 },
  { dia: 12, g: 4,  p: 3,  estado: 'W', b30k: 8379,    b100k: 27930,   b500k: 139650,   b1m: 279300 },
  { dia: 13, g: 5,  p: 4,  estado: 'W', b30k: 8424,    b100k: 28080,   b500k: 140400,   b1m: 280800 },
  { dia: 14, g: 6,  p: 4,  estado: 'W', b30k: 8718,    b100k: 29060,   b500k: 145300,   b1m: 290600 },
  { dia: 15, g: 10, p: 0,  estado: 'W', b30k: 11208,   b100k: 37360,   b500k: 186800,   b1m: 373600 },
  { dia: 16, g: 3,  p: 10, estado: 'LL',b30k: 9288,    b100k: 30960,   b500k: 154800,   b1m: 309600 },
  { dia: 17, g: 5,  p: 2,  estado: 'W', b30k: 9933,    b100k: 33110,   b500k: 165550,   b1m: 331100 },
  { dia: 18, g: 6,  p: 1,  estado: 'W', b30k: 11127,   b100k: 37090,   b500k: 185450,   b1m: 370900 },
  { dia: 19, g: 7,  p: 4,  estado: 'W', b30k: 11670,   b100k: 38900,   b500k: 194500,   b1m: 389000 },
  { dia: 20, g: 5,  p: 6,  estado: 'L', b30k: 11115,   b100k: 37050,   b500k: 185250,   b1m: 370500 },
  { dia: 21, g: 6,  p: 4,  estado: 'W', b30k: 11409,   b100k: 38030,   b500k: 190150,   b1m: 380300 },
  { dia: 22, g: 3,  p: 3,  estado: 'L', b30k: 11256,   b100k: 37520,   b500k: 187600,   b1m: 375200 },
  { dia: 23, g: 5,  p: 3,  estado: 'W', b30k: 11601,   b100k: 38670,   b500k: 193350,   b1m: 386700 },
  { dia: 24, g: 6,  p: 5,  estado: 'L', b30k: 11595,   b100k: 38650,   b500k: 193250,   b1m: 386500 },
  { dia: 25, g: 6,  p: 3,  estado: 'W', b30k: 12189,   b100k: 40630,   b500k: 203150,   b1m: 406300 },
  { dia: 26, g: 8,  p: 2,  estado: 'W', b30k: 13581,   b100k: 45270,   b500k: 226350,   b1m: 452700 },
  { dia: 27, g: 4,  p: 2,  estado: 'W', b30k: 13977,   b100k: 46590,   b500k: 232950,   b1m: 465900 },
  { dia: 28, g: 6,  p: 3,  estado: 'W', b30k: 14571,   b100k: 48570,   b500k: 242850,   b1m: 485700 },
  { dia: 29, g: 7,  p: 3,  estado: 'W', b30k: 15414,   b100k: 51380,   b500k: 256900,   b1m: 513800 },
  { dia: 30, g: 6,  p: 1,  estado: 'W', b30k: 16608,   b100k: 55360,   b500k: 276800,   b1m: 553600 },
  { dia: 31, g: 7,  p: 3,  estado: 'CIERRE', b30k: 17451, b100k: 58170, b500k: 290850, b1m: 581700 },
];

const fmt = (n) => {
  const signo = n >= 0 ? '+' : '−';
  const abs = Math.abs(n);
  return signo + '$' + abs.toLocaleString('es-CL');
};

const ResultadosMesModal = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div className="rmm-overlay" onClick={onClose}>
      <div className="rmm-modal" onClick={(e) => e.stopPropagation()}>

        <div className="rmm-header">
          <div className="rmm-header-top">
            <span className="rmm-badge">RESULTADOS DEL MES</span>
            <button className="rmm-close" onClick={onClose} aria-label="Cerrar">
              ✕
            </button>
          </div>
          <h2 className="rmm-title">Así funciona el motor</h2>
          <p className="rmm-subtitle">Cómo se ve un mes con disciplina</p>
        </div>

        <div className="rmm-content">

          <p className="rmm-intro">
            El motor <strong>perdió 7 días y ganó 24</strong>. Incluso con un día muy malo
            (3 aciertos / 10 fallos), el mes cerró en positivo.
          </p>

          <div className="rmm-perdidas-banner">
            <p className="rmm-perdidas-titulo">DÍAS EN PÉRDIDA (7 de 31)</p>
            <p className="rmm-perdidas-lista">
              Día 1 · Día 9 · Día 10 · <strong>Día 16 (peor: 3 / 10)</strong> · Día 20 · Día 22 · Día 24
            </p>
          </div>

          <div className="rmm-tabla-wrapper">
            <table className="rmm-tabla">
              <thead>
                <tr>
                  <th>día</th>
                  <th>gana</th>
                  <th>pierde</th>
                  <th></th>
                  <th>$30.000</th>
                  <th>$100.000</th>
                  <th>$500.000</th>
                  <th>$1.000.000</th>
                </tr>
              </thead>
              <tbody>
                {DATOS_31_DIAS.map((fila) => (
                  <tr key={fila.dia} className={`rmm-fila rmm-fila-${fila.estado}`}>
                    <td>{fila.dia}</td>
                    <td>{fila.g}</td>
                    <td>{fila.p}</td>
                    <td className="rmm-icono">
                      {fila.estado === 'W' && '✅'}
                      {fila.estado === 'CIERRE' && '🏆'}
                      {fila.estado === 'L' && '❌'}
                      {fila.estado === 'LL' && '❌❌'}
                    </td>
                    <td>{fmt(fila.b30k)}</td>
                    <td>{fmt(fila.b100k)}</td>
                    <td>{fmt(fila.b500k)}</td>
                    <td>{fmt(fila.b1m)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <p className="rmm-scroll-cue">← Desliza →</p>

          <p className="rmm-tabla-hint">
            Filas rojas = días perdedores · Última fila = cierre del mes
          </p>

          <div className="rmm-dia16-banner">
            <p>
              <strong>El día 16 fue durísimo:</strong> con banca $1.000.000 el motor perdió
              −$64.000 en un solo día (3 aciertos / 10 fallos). Pero el cliente disciplinado siguió.{' '}
              <strong>Quince días después el mes cerró en +$581.700.</strong>
            </p>
          </div>

          <p className="rmm-reglas-titulo">LO QUE TIENES QUE ENTENDER</p>

          <div className="rmm-reglas">
            <div className="rmm-regla">
              <div className="rmm-regla-icono rmm-regla-icono-rojo">↓</div>
              <p><strong>Vas a tener días muy malos</strong> (incluso 3 aciertos / 10 fallos). Es matemáticamente posible con acierto 60%.</p>
            </div>
            <div className="rmm-regla">
              <div className="rmm-regla-icono rmm-regla-icono-amber">=</div>
              <p><strong>Mantén el stake constante</strong> incluso después de un día como el 16. No subas la apuesta para "recuperar" rápido.</p>
            </div>
            <div className="rmm-regla">
              <div className="rmm-regla-icono rmm-regla-icono-verde">🏆</div>
              <p><strong>Lo que cuenta es el cierre del mes</strong>, no un día puntual ni una racha mala.</p>
            </div>
          </div>

          <p className="rmm-disclaimer">
            Mes de referencia · resultados no idénticos
          </p>

          <button className="rmm-cta" onClick={onClose}>
            Entendido
          </button>

        </div>

      </div>
    </div>
  );
};

export default ResultadosMesModal;
